export const TOOL_TASK = 'update-user-group';
export const TOOL_TITLE = 'Update User Group';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once updating user group finishes';
export const FILE_NAME = 'Update-user-group-report';
export const FILE_HEADERS = {
    userId: 'User Id',
    userEmail: 'Email',
    oldGroupName: 'Old Account Group',
    newGroupName: 'New Account Group',
    actionStatus: 'Action Status',
};

export const TOOL_PROGRESS_LABEL = 'Bulk user group updating progress...';
export const MULTIPLE_ACCOUNT_SELECT_ERROR = 'You can only set Account Groups for multiple users in the same Account';

export const GROUP_MODAL_TITLES = {
    ASSIGN: 'Assign To Group',
    UPDATE: 'Update Group Members',
    UNASSIGN: 'Unassign From Group',
};

export const MODAL_WIDTH = 400;
export const UNASSIGN_MODAL_WIDTH = 500;
